<template>
  <li>
    <span
      class="rating-label"
      :class="`interview-${label}`"
      data-test="label-style"
    ><img :src="`${imageUrl}/interview_${label}.png`"></span>
    <ul class="star-list">
      <li
        v-for="(i) in value"
        :key="`star-${i}`"
      >
        <img
          class="blue-star"
          data-test="test-stars"
          :src="`${imageUrl}/interview_star_img.png`"
        >
      </li>
      <li
        v-for="(i) in 5 - value"
        :key="`blank-star-${i}`"
      >
        <img
          class="blue-star"
          data-test="test-blank-stars"
          :src="`${imageUrl}/interview_star_none_img.png`"
        >
      </li>
    </ul>
  </li>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/jobinterview/base" as *;
</style>

<script>
const USER_URL = process.env.USER_ENDPOINT

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    imageUrl: () => `${USER_URL}/th/pc/img/jobinterview`
  }
}
</script>
